
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import classNames from "classnames";
// import Coin_exchange from "./coin_exchange";
// import Option from "./option";
// import Exchange from "./exchange";
import Cash_diary from './../../nhatkyorders.jsx';
import History_vip_1 from "./history_vip_1";
import History_vip_2 from "./history_vip_2";
import History_vip_3 from "./history_vip_3";

const Coin_home = () => {
    const { slug_2 } = useParams();
    const [userOption, setUserOption] = useState("changeCard");
    const navigate = useNavigate();
    return (
        <>
            {slug_2 === "history_vip_2" && (
                <History_vip_2 />
            )}
            {slug_2 === "history_vip_3" && (
                <History_vip_3 />
            )}
            {slug_2 === "history_vip_1" && (
                <History_vip_1 />
            )}
            {slug_2 === "cash_diary" && (
                <Cash_diary category_main={'referrals'}/>
            )}
        </>
    );
}

export default Coin_home;
